import React from "react";

export default function ClickImagePlayAudio({ props }) {
  const answerArray = props || [];
  const clicked = React.useRef(false);

  React.useEffect(() => {
    const images = document.querySelectorAll("#answer");
    const successAudio = document.getElementById("success-audio");
    const faliAudio = document.getElementById("fail-audio");

    for (let i = 0; i < images.length; i++) {
      images[i].addEventListener("click", function () {
        const answer = answerArray[i];
        clicked.current = true;
        playAudio(answer);
      });
    }

    const playAudio = (answer) => {
      if (clicked.current) {
        if (answer === "true") {
          successAudio.play();
        } else {
          faliAudio.play();
        }
      }
    };
  });

  return (
    <>
      <audio
        id="success-audio"
        src="/Audios/page6/success-Sound.mp3"
        style={{ display: "none" }}
      ></audio>
      <audio
        id="fail-audio"
        src="/Audios/page6/fails.mp3"
        style={{ display: "none" }}
      ></audio>
    </>
  );
}
